export function mergeFollowUpDraft(base, local, remote, fields) {
    const merged = { ...remote, version: remote.version };
    const conflicts = [];
    fields.forEach(field => {
        const localChanged = !sameMergeValue(local[field], base[field]);
        const remoteChanged = !sameMergeValue(remote[field], base[field]);
        if (localChanged && remoteChanged && !sameMergeValue(local[field], remote[field])) {
            conflicts.push(field);
        } else if (localChanged) {
            merged[field] = local[field];
        }
    });
    merged.patient = `${merged.patientNom || ""} ${merged.patientPrenom || ""}`.trim();
    return { merged, conflicts };
}

function sameMergeValue(first, second) {
    return JSON.stringify(first ?? null) === JSON.stringify(second ?? null);
}
